import renderExtensionView from "./lib/render-extension-view.js";
import VideoOverlay from "./components/VideoOverlay/VideoOverlay.js";

renderExtensionView(<VideoOverlay />);
